import React from "react";
import {
  Grid,
  Typography,
  Box,
  Paper,
  styled
} from "@mui/material";
import { useTheme } from "@emotion/react";
import InfoDataTooltip from "./InfoDataTooltip";


const Item = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "theme",
})(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#F9F5EB",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  borderRadius: "5px",
  width: "auto",
  [theme.breakpoints.down("sm")]: {
    width: "327px",
  },
}));



const removeDuplicates = (data) => {
  let uniqueRecords = [];
  let uniqueKeys = new Set(); // To store unique combinations of keys

  data.forEach((record) => {
    // Form a unique key using the desired properties
    let key = `${record.name}-${record.timestamp}-${record.timestamp_end}-${record.value}`;
    // Check if the key is not already in the set of unique keys
    if (!uniqueKeys.has(key)) {
      uniqueKeys.add(key); // Add the key to the set
      uniqueRecords.push(record); // Add the record to the list of unique records
    }
  });

  return uniqueRecords;
};

const InfoDataBox = ({ infoindex, infoData, infoName, compactProjectDetail, forceGreenText = false }) => {
  const theme = useTheme();

  let metrics = infoData;
  
  if (metrics.type === 'metrics_group') {
    metrics = removeDuplicates(infoData.metrics);
  }

  return (
    <>
      {(
        (infoData.type === 'metrics_group' &&  metrics.length > 0)
        || (infoData.type === 'metric')
      ) && (
        <Grid
          item
          xs={6}
          mb={3}
          sx={{
            maxWidth: compactProjectDetail ? "100%!important" : '',
            width: compactProjectDetail ? "100%!important" : '',
            flexGrow: compactProjectDetail ? "1!important" : '0',
            [theme.breakpoints.down("sm")]: {
              maxWidth: "327px!important",
              width: "327px"
            },
          }}
        >
          <Item theme={theme}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                paddingTop: "15px",
                paddingLeft: "20px",
              }}
              p={3}
            >
              <img
                src={infoData.type === 'metric' ? infoData.data.resources.access_url : infoData.icon}
                alt="grid-icon"
                style={{
                  paddingRight: "2rem",
                  filter:
                    "invert(20%) sepia(66%) saturate(510%) hue-rotate(75deg) brightness(95%) contrast(96%)",
                }}
              />
              {infoData.type === 'metrics_group' ? (
                <Box
                  sx={{ borderLeft: "1px solid #D8D5CC", paddingLeft: "2rem" }}
                >
                  {metrics.map((data, idx) => (
                    <Box key={idx} mb={3}>
                      <Typography
                        variant="h3"
                        mb={1}
                        fontWeight={500}
                        color={
                          forceGreenText || (
                            data.resources.identifier.toLowerCase().includes("detected")
                            || data.name.includes("detected")
                          ) ? "#164A1A" : "#919397"
                        }
                      >
                        {data.formatted_value}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography
                          variant="subtitle2"
                          mr={1}
                          mb={2}
                          color={"#626364"}
                        >
                          {data.resources.caption_text} ({data?.formatted_unit})
                        </Typography>
                        <InfoDataTooltip data={data} index={infoindex} infoName={infoName}/>
                      </Box>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box sx={{ paddingLeft: "2rem" }}>
                  <Box>
                    <Typography
                      variant="h3"
                      mb={1}
                      fontWeight={500}
                      color={"#164A1A"}
                      style={{ fontFamily: '"MADE TOMMY", sans-serif' }}
                    >
                      {metrics.data.formatted_value}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                      <Typography variant="subtitle2" mr={1} mb={2} color={"#626364"}
                        sx={{
                          fontSize: 14,
                          fontFamily: 'MADE TOMMY',
                          fontWeight: '400',
                          wordWrap: 'break-word',
                          textTransform: 'capitalize'
                        }}>
                        {metrics.data.resources.caption_text} ({metrics.data.formatted_unit})
                      </Typography>
                      <InfoDataTooltip data={metrics.data} index={infoindex} infoName={infoName}/>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </Item>
        </Grid>
      )}
    </>
  );
};

export default InfoDataBox;
